import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';

import { DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL } from '../../constants';
import { OrderItem } from '../../types';
import { OrderItemsActions } from '../OrderItemsActions';

import { DisplayProps } from '.';

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ orderItem, orderId }: DisplayProps): JSX.Element | null => {
  return (
    <div
      data-hc-name={`${DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL}-in-order-actions`}
    >
      {orderId && <OrderItemsActions orderItem={orderItem} orderId={orderId} />}
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = ({ ...tableHeaderCellProps }) => {
  return <TableHeaderCell {...tableHeaderCellProps}></TableHeaderCell>;
};

const defaultHeaderCellProps: Partial<TableHeaderCellProps> = {
  isTableHeaderCell: true,
};

HeaderCell.defaultProps = defaultHeaderCellProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({
  orderItem,
  orderId,
  ...tableCellProps
}: {
  orderItem: OrderItem;
  orderId?: number;
}) => {
  return (
    <TableCell {...tableCellProps}>
      <Display orderItem={orderItem} orderId={orderId} />
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  isTableCell: true,
};

ContentCell.defaultProps = defaultContentProps;

export const ORDER_ITEM_IN_ORDER_ACTIONS_CONFIG = {
  HeaderCell,
  ContentCell,
  label: 'Action',
};
